import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initGA, usePageviewTracking } from "./utils/analytics";
import Homepage from "./pages/thesignaturetours/Homepage";
import ListingPage from "./pages/thesignaturetours/ListingPage";
import ShowPage from "./pages/thesignaturetours/ShowPage";
import CountriesPage from "./pages/thesignaturetours/CountriesPage";
import BlogPage from "./pages/thesignaturetours/BlogPage";
import BlogShowPage from "./pages/thesignaturetours/BlogShowPage";
import ContactAgentsPage from "./pages/thesignaturetours/ContactAgentsPage";
import ContactUsPage from "./pages/thesignaturetours/ContactUsPage";
import AboutUsPage from "./pages/thesignaturetours/AboutUsPage";
import MainLayout from './layouts/thesignaturetours/MainLayout';

function Inner() {
  const location = useLocation();

  usePageviewTracking();

  return (
    <Routes>
      <Route path="/web" element={<MainLayout />}>
        <Route index element={<Homepage />} />
        <Route path="/web/listing" element={<ListingPage />} />
        <Route path="/web/itinerary/:id" element={<ShowPage />} />
        <Route path="/web/about-us" element={<AboutUsPage />} />
        <Route path="/web/countries" element={<CountriesPage />} />
        <Route path="/web/blog" element={<BlogPage />} />
        <Route path="/web/blog/:id" element={<BlogShowPage />} />
        <Route path="/web/contact-agents" element={<ContactAgentsPage />} />
        <Route path="/web/contact-us" element={<ContactUsPage />} />
      </Route>
    </Routes>
  );
}

export default function thesignaturetours(props: {google_tracking_id?: string}) {
  initGA(props.google_tracking_id);
  return (
    <BrowserRouter>
      <Inner />
    </BrowserRouter>
  );
}